import { render, staticRenderFns } from "./CatalogInstancesList.vue?vue&type=template&id=508d8fae"
import script from "./CatalogInstancesList.vue?vue&type=script&lang=js"
export * from "./CatalogInstancesList.vue?vue&type=script&lang=js"
import style0 from "./CatalogInstancesList.vue?vue&type=style&index=0&id=508d8fae&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports